import { useOutletContext } from 'react-router-dom';

import { AdminSection, OutletContext } from '@typings';
import { userSelector } from '@selectors';
import { useSelector } from '@hooks';
import { getDashboardLinkParams } from '@utils';

import { DashboardReportLink } from '@components/Ui';

const MANAGE_REPORT_LINKS = [
  { source: 'overview', refreshTimeoutMinutes: '1m' },
  { source: 'nodes', refreshTimeoutMinutes: '1m' },
  { source: 'jobs', refreshTimeoutMinutes: '1m' },
  { source: 'services', refreshTimeoutMinutes: '1m' },
  { source: 'credits', refreshTimeoutMinutes: '5m' },
  { source: 'prices', refreshTimeoutMinutes: '5m' },
] as const;

const USER_REPORT_LINKS = [
  { source: 'jobs', refreshTimeoutMinutes: '1m' },
  { source: 'prices', refreshTimeoutMinutes: '5m' },
] as const;

export const AdminSectionClusterReportsPage = () => {
  const { cluster } = useOutletContext<OutletContext.AdminSectionCluster>();

  const { systemRole } = useSelector(userSelector);

  const getDashboardReportLink = ({
    source,
    refreshTimeoutMinutes,
  }: (typeof MANAGE_REPORT_LINKS)[number]) => {
    const params = getDashboardLinkParams({
      source,
      titlePattern: 'Cluster {{source}} dashboard',
    });

    return (
      <DashboardReportLink
        {...params}
        metricsUrl={cluster.metrics.url}
        params={{ orgId: '1', refresh: refreshTimeoutMinutes }}
      />
    );
  };

  const renderContent = () => {
    if (systemRole !== AdminSection.Role.User) {
      return MANAGE_REPORT_LINKS.map(getDashboardReportLink);
    }

    return USER_REPORT_LINKS.map(getDashboardReportLink);
  };

  return <div className="flex flex-wrap gap-10 p-10">{renderContent()}</div>;
};
